import { defineMessages } from 'react-intl';

export const reservationMessages = defineMessages({
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    scheduledChanges: {
        id: 'scheduled-changes',
        defaultMessage: 'Scheduled changes',
    },
    parkingZones: {
        id: 'parking-zones',
        defaultMessage: 'Parking zones',
    },
    activeFrom: {
        id: 'active-from',
        defaultMessage: 'Active from',
    },
    activeTo: {
        id: 'active-to',
        defaultMessage: 'Active to',
    },
    reservationPlans: {
        id: 'reservation-plans',
        defaultMessage: 'Reservation plans',
    },
    active: {
        id: 'active',
        defaultMessage: 'Active',
    },
    inactive: {
        id: 'inactive',
        defaultMessage: 'Inactive',
    },
    version: {
        id: 'version',
        defaultMessage: 'Version',
    },
    hourly: {
        id: 'hourly',
        defaultMessage: 'Hourly',
    },
    daily: {
        id: 'daily',
        defaultMessage: 'Daily',
    },
    fixedDuration: {
        id: 'fixed-duration',
        defaultMessage: 'Fixed duration',
    },
    fixedPlans: {
        id: 'fixed-reservation-plans',
        defaultMessage: 'Fixed plans',
    },
    dynamicPlans: {
        id: 'dynamic-reservation-plans',
        defaultMessage: 'Dynamic plans',
    },
    latestVersion: {
        id: 'latest-version',
        defaultMessage: 'Latest version',
    },
    backReservations: {
        id: 'back-reservations',
        defaultMessage: 'Back to all reservations',
    },
    details: {
        id: 'details',
        defaultMessage: 'Details',
    },
    versions: {
        id: 'versions',
        defaultMessage: 'Versions',
    },
    isActive: {
        id: 'is-active',
        defaultMessage: 'Is active',
    },
    pricingPlanAtAGlimpse: {
        id: 'pricing-plan-at-a-glimpse',
        defaultMessage: 'Pricing plan at a glimpse',
    },
    stayRules: {
        id: 'stay-rules',
        defaultMessage: 'Stay rules',
    },
    stayDuration: {
        id: 'stay-duration',
        defaultMessage: 'Stay duration',
    },
    allowedSpots: {
        id: 'allowed-spots',
        defaultMessage: 'Allowed spots',
    },
    entryTolerance: {
        id: 'entry-tolerance',
        defaultMessage: 'Entry tolerance in minutes',
    },
    exitTolerance: {
        id: 'exit-tolerance',
        defaultMessage: 'Exit tolerance in minutes',
    },
    entryToleranceTableCol: {
        id: 'entry-tolerance-table-col',
        defaultMessage: 'Entry tolerance',
    },
    exitToleranceTableCol: {
        id: 'exit-tolerance-table-col',
        defaultMessage: 'Exit tolerance',
    },
    reservedSpot: {
        id: 'reserved-spot',
        defaultMessage: 'Reserved spot',
    },
    cancellationRules: {
        id: 'cancellation-rules',
        defaultMessage: 'Cancellation rules',
    },
    cancellation: {
        id: 'cancellation',
        defaultMessage: 'Cancellation',
    },
    freeCancellation: {
        id: 'free-cancellation',
        defaultMessage: 'Free',
    },
    paidCancellation: {
        id: 'paid-cancellation',
        defaultMessage: 'Paid',
    },
    noCancellation: {
        id: 'no-cancellation',
        defaultMessage: 'No cancellation',
    },
    activeReservations: {
        id: 'active-reservations',
        defaultMessage: 'Active reservations',
    },
    upcomingReservations: {
        id: 'upcoming-reservations',
        defaultMessage: 'Upcoming reservations',
    },
    totalVersions: {
        id: 'total-versions',
        defaultMessage: 'Total versions',
    },
    cancellationPrice: {
        id: 'cancellation-price',
        defaultMessage: 'Price without VAT',
    },
    cancellationVAT: {
        id: 'cancellation-vat',
        defaultMessage: 'VAT amount',
    },
    cancellationPriceVat: {
        id: 'cancellation-price-vat',
        defaultMessage: 'Price with VAT',
    },
    reservationValidFrom: {
        id: 'reservation-valid-from',
        defaultMessage: 'Valid from',
    },
    reservationValidTo: {
        id: 'reservation-valid-to',
        defaultMessage: 'Valid to',
    },
    reservationDurationStart: {
        id: 'reservation-duration-start',
        defaultMessage: 'Duration start date',
    },
    reservationDurationEnd: {
        id: 'reservation-duration-end',
        defaultMessage: 'Duration end date',
    },
    reservationDurationStartForm: {
        id: 'reservation-duration-start-form',
        defaultMessage: 'Start date',
    },
    reservationDurationEndForm: {
        id: 'reservation-duration-end-form',
        defaultMessage: 'End date',
    },
    totalReservations: {
        id: 'total-reservations',
        defaultMessage: 'Total reservations',
    },
    reservationPlanVersions: {
        id: 'reservation-plan-versions',
        defaultMessage: 'Reservation plan versions',
    },
    addNewVersion: {
        id: 'add-new-version',
        defaultMessage: 'New version',
    },
    addNewReservationType: {
        id: 'add-new-reservation-type',
        defaultMessage: 'New reservation plan',
    },
    newVersionDescription: {
        id: 'new-version-description',
        defaultMessage: 'Create a new version',
    },
    newReservationTypeDescription: {
        id: 'new-reservation-type-description',
        defaultMessage: 'Create a new reservation plan',
    },
    selectCancellation: {
        id: 'select-cancellation',
        defaultMessage: 'Select cancellation policy',
    },
    selectCurrency: {
        id: 'select-currency',
        defaultMessage: 'Select currency',
    },
    deleteVersion: {
        id: 'delete-version',
        defaultMessage: 'Delete version',
    },
    deletePlan: {
        id: 'delete-reservation-plan',
        defaultMessage: 'Delete Plan',
    },
    confirmDeleteVersion: {
        id: 'confirm-delete-version',
        defaultMessage: 'Are you sure you want to delete version {versionName}? This action cannot be undone.',
    },
    confirmDeletePlan: {
        id: 'confirm-delete-reservation-plan',
        defaultMessage: 'Are you sure you want to delete plan {versionName}? This action cannot be undone.',
    },
    deleteVersionSuccess: {
        id: 'delete-version-success',
        defaultMessage: 'Version deleted',
    },
    deleteVersionSuccessDetails: {
        id: 'delete-version-success-details',
        defaultMessage: 'Version {versionName} successfully deleted',
    },
    versionCreateSuccess: {
        id: 'version-create-success',
        defaultMessage: 'Version created',
    },
    versionCreateSuccessDetails: {
        id: 'version-create-success-details',
        defaultMessage: 'Reservation plan version successfully created.',
    },
    reservationTypeCreateSuccess: {
        id: 'reservation-type-create-success',
        defaultMessage: 'Reservation plan created',
    },
    reservationTypeCreateSuccessDetails: {
        id: 'reservation-type-create-success-details',
        defaultMessage: 'Reservation plan successfully created.',
    },
    editActiveStatusSuccess: {
        id: 'edit-active-status-success',
        defaultMessage: 'Status updated',
    },
    editActiveStatusSuccessDescription: {
        id: 'edit-active-status-success-description',
        defaultMessage: 'The status has been successfully updated.',
    },
    editVersion: {
        id: 'edit-version',
        defaultMessage: 'Edit version',
    },
    editVersionSuccess: {
        id: 'edit-version-success',
        defaultMessage: 'Version updated successfully.',
    },
    editVersionSuccessDescription: {
        id: 'edit-version-success-description',
        defaultMessage: 'Version updated successfully.',
    },
    reservations: {
        id: 'reservations',
        defaultMessage: 'Reservations',
    },
    reservationType: {
        id: 'reservation-type',
        defaultMessage: 'Reservation type',
    },
    selectReservationType: {
        id: 'select-reservation-type',
        defaultMessage: 'Select reservation type',
    },
    customer: {
        id: 'customer',
        defaultMessage: 'Customer',
    },
    reservationNumber: {
        id: 'reservation-number',
        defaultMessage: 'Reservation number',
    },
    waiting: {
        id: 'waiting',
        defaultMessage: 'Waiting',
    },
    cancelled: {
        id: 'cancelled',
        defaultMessage: 'Cancelled',
    },
    paid: {
        id: 'paid',
        defaultMessage: 'Paid',
    },
    failed: {
        id: 'failed',
        defaultMessage: 'Failed',
    },
    licensePlate: {
        id: 'license-plate',
        defaultMessage: 'License plate',
    },
    clientInformation: {
        id: 'client-information',
        defaultMessage: 'Client details',
    },
    phoneNumber: {
        id: 'phone-number',
        defaultMessage: 'Phone number',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    device: {
        id: 'device',
        defaultMessage: 'Device',
    },
    ip: {
        id: 'ip',
        defaultMessage: 'IP',
    },
    region: {
        id: 'region',
        defaultMessage: 'Region',
    },
    payment: {
        id: 'payment',
        defaultMessage: 'Payment',
    },
    paymentType: {
        id: 'payment-type',
        defaultMessage: 'Payment type',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    paymentStatus: {
        id: 'payment-status',
        defaultMessage: 'Payment status',
    },
    createdAt: {
        id: 'created-at',
        defaultMessage: 'Created at',
    },
    reservationNumbers: {
        id: 'reservation-numbers',
        defaultMessage: 'Number',
    },
    paymentNumber: {
        id: 'payment-number',
        defaultMessage: 'Payment number',
    },
    currentVersion: {
        id: 'current-version',
        defaultMessage: 'Current version',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    versionName: {
        id: 'version-name',
        defaultMessage: 'Version name',
    },
    versionDescription: {
        id: 'version-description',
        defaultMessage: 'Version description',
    },
    reservation: {
        id: 'reservation',
        defaultMessage: 'Reservation',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    paymentOperator: {
        id: 'payment-operator',
        defaultMessage: 'Payment operator',
    },
    transactionId: {
        id: 'transaction-id',
        defaultMessage: 'Transaction ID',
    },
    completedOn: {
        id: 'completed-on',
        defaultMessage: 'Completed on',
    },
    pending: {
        id: 'pending',
        defaultMessage: 'Pending',
    },
    successful: {
        id: 'successful',
        defaultMessage: 'Successful',
    },
    rollback: {
        id: 'rollback',
        defaultMessage: 'Rollback',
    },
    copy: {
        id: 'copy',
        defaultMessage: 'Copy',
    },
    actions: {
        id: 'actions',
        defaultMessage: 'Actions',
    },
    plans: {
        id: 'plans',
        defaultMessage: 'Plans',
    },
    vehicleStatus: {
        id: 'vehicle-status',
        defaultMessage: 'Vehicle status',
    },
    enteredAt: {
        id: 'entered-at',
        defaultMessage: 'Entered at',
    },
    exited: {
        id: 'exited',
        defaultMessage: 'Exited',
    },
    totalStay: {
        id: 'total-stay',
        defaultMessage: 'Total stay',
    },
    edit: {
        id: 'edit',
        defaultMessage: 'Edit',
    },
    downloadReceipt: {
        id: 'download-receipt',
        defaultMessage: 'Download receipt',
    },
    viewReceipt: {
        id: 'view-receipt',
        defaultMessage: 'View receipt',
    },
    sendConfirmation: {
        id: 'send-confirmation',
        defaultMessage: 'Send confirmation',
    },
    sendConfirmationDescription: {
        id: 'send-confirmation-description',
        defaultMessage: 'Send confirmation for reservation #{reservationNumber}',
    },
    refundPayment: {
        id: 'refund-payment',
        defaultMessage: 'Refund payment',
    },
    cancelReservation: {
        id: 'cancel-reservation',
        defaultMessage: 'Cancel reservation',
    },
    inParking: {
        id: 'in-parking',
        defaultMessage: 'In parking',
    },
    notInParking: {
        id: 'not-in-parking',
        defaultMessage: 'Not in parking',
    },
    editReservation: {
        id: 'edit-reservation',
        defaultMessage: 'Edit reservation',
    },
    editReservationDetails: {
        id: 'edit-reservation-details',
        defaultMessage: 'Change the reservation details',
    },
    editReservationSuccess: {
        id: 'edit-reservation-success',
        defaultMessage: 'Reservation updated successfully.',
    },
    vehicleDetails: {
        id: 'vehicle-details',
        defaultMessage: 'Vehicle details',
    },
    upcoming: {
        id: 'upcoming',
        defaultMessage: 'Upcoming',
    },
    past: {
        id: 'past',
        defaultMessage: 'Past',
    },
    waitingPayment: {
        id: 'waiting-payment',
        defaultMessage: 'Waiting payment',
    },
    failedPayment: {
        id: 'failed-payment',
        defaultMessage: 'Failed payment',
    },
    reservationDetails: {
        id: 'reservation-details',
        defaultMessage: 'Reservation details',
    },
    copyVersionDetails: {
        id: 'copy-version-details',
        defaultMessage: 'Copy version details',
    },
    editVersionDetails: {
        id: 'edit-version-details',
        defaultMessage: 'Edit version details',
    },
    plan: {
        id: 'plan',
        defaultMessage: 'Plan',
    },
    cancelReservationTitle: {
        id: 'cancel-reservation-title',
        defaultMessage: 'Cancel reservation',
    },
    confirmCancelReservation: {
        id: 'confirm-cancel-reservation',
        defaultMessage:
            'Are you sure you want to cancel reservation #{reservationNumber}? This action cannot be undone. Canceling the reservation does not refund your payment',
    },
    cancelReservationSuccess: {
        id: 'cancel-reservation-success',
        defaultMessage: 'Reservation cancelled',
    },
    cancelReservationSuccessDetails: {
        id: 'cancel-reservation-success-details',
        defaultMessage: 'Reservation #{reservationNumber} has been successfully cancelled.',
    },
    sendConfirmationTo: {
        id: 'send-confirmation-to',
        defaultMessage: 'Send confirmation to {client_email}',
    },
    confirmationSentSuccess: {
        id: 'confirmation-sent-success',
        defaultMessage: 'Confirmation sent',
    },
    confirmationSentSuccessDetails: {
        id: 'confirmation-sent-success-details',
        defaultMessage: 'Confirmation was sent successfully to {client_email}.',
    },
    editReservationSuccessDetails: {
        id: 'edit-reservation-success-details',
        defaultMessage: 'Reservation #{reservationNumber} has been successfully updated.',
    },
    refundPaymentDescription: {
        id: 'refund-payment-description',
        defaultMessage: 'Refund payment for reservation #{reservationNumber}',
    },
    refundPaymentConfirmation: {
        id: 'refund-payment-confirmation',
        defaultMessage:
            'Are you sure you want to refund the payment for reservation #{reservationNumber}? Refunding the payment does not cancel the reservation.',
    },
    reserveSpotPlaceholder: {
        id: 'reserve-spot-placeholder',
        defaultMessage: 'Select reserve spot policy',
    },
    refundPaymentSuccess: {
        id: 'refund-payment-success',
        defaultMessage: 'Payment refunded successfully.',
    },
    refundPaymentSuccessDescription: {
        id: 'refund-payment-success-description',
        defaultMessage: 'Payment refund was successful for reservation #{reservationNumber}.',
    },
    refunded: {
        id: 'refunded',
        defaultMessage: 'Refunded',
    },
    beginning: {
        id: 'beginning',
        defaultMessage: 'Beginning',
    },
    ending: {
        id: 'ending',
        defaultMessage: 'Ending',
    },
    minutes: {
        id: 'duration-reservation-minutes',
        defaultMessage: '{value, plural, =0 {# minutes} one {# minute} other {# minutes}}',
    },
    hours: {
        id: 'duration-reservation-hours',
        defaultMessage: '{value, plural, =0 {# hours} one {# hour} other {# hours}}',
    },
    days: {
        id: 'duration-reservation-days',
        defaultMessage: '{value, plural, =0 {# days} one {# day} other {# days}}',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    allowedEntryAt: {
        id: 'allowed-entry-at',
        defaultMessage: 'Allowed entry at',
    },
    allowedExitAt: {
        id: 'allowed-exit-time',
        defaultMessage: 'Allowed exit at',
    },
    doesMembershipExists: {
        id: 'does-membership-exists',
        defaultMessage: 'Created membership',
    },
    reservationCreatedAt: {
        id: 'reservation-created-at',
        defaultMessage: 'Created at',
    },
    reservationPaymentOrderCreatedAt: {
        id: 'reservation-payment-order-created-at',
        defaultMessage: 'Created at',
    },
    pricing: {
        id: 'pricing',
        defaultMessage: 'Pricing',
    },
    priceWithVat: {
        id: 'price-with-vat',
        defaultMessage: 'Price with VAT',
    },
    vat: {
        id: 'vat',
        defaultMessage: 'VAT',
    },
    vatAmount: {
        id: 'vat-amount',
        defaultMessage: 'VAT amount',
    },
    priceWithoutVat: {
        id: 'reservation-price-without-vat',
        defaultMessage: 'Price without VAT',
    },
    price: {
        id: 'price',
        defaultMessage: 'Price',
    },
    zones: {
        id: 'zones',
        defaultMessage: 'Zones',
    },
    allowLists: {
        id: 'allow-lists',
        defaultMessage: 'Allow lists',
    },
    maxStartDateDays: {
        id: 'max-start-date-days',
        defaultMessage: 'Max start date days',
    },
    maxDuration: {
        id: 'max-duration',
        defaultMessage: 'Max duration (seconds)',
    },
});
